import { PrismLight as SyntaxHighlighter } from 'react-syntax-highlighter';
import vscDarkPlus from 'react-syntax-highlighter/dist/esm/styles/prism/vsc-dark-plus';
import hcl from 'react-syntax-highlighter/dist/esm/languages/prism/hcl';
import bash from 'react-syntax-highlighter/dist/esm/languages/prism/bash';
import json from 'react-syntax-highlighter/dist/esm/languages/prism/json';
import yaml from 'react-syntax-highlighter/dist/esm/languages/prism/yaml';
import powershell from 'react-syntax-highlighter/dist/esm/languages/prism/powershell';
import sql from 'react-syntax-highlighter/dist/esm/languages/prism/sql';
import python from 'react-syntax-highlighter/dist/esm/languages/prism/python';
import docker from 'react-syntax-highlighter/dist/esm/languages/prism/docker';
import ini from 'react-syntax-highlighter/dist/esm/languages/prism/ini';
import javascript from 'react-syntax-highlighter/dist/esm/languages/prism/javascript';
import typescript from 'react-syntax-highlighter/dist/esm/languages/prism/typescript';
import markup from 'react-syntax-highlighter/dist/esm/languages/prism/markup';

// Register only the languages the assistant produces, to keep the bundle small
[
  ['hcl', hcl], ['bash', bash], ['json', json], ['yaml', yaml], ['powershell', powershell],
  ['sql', sql], ['python', python], ['docker', docker], ['ini', ini], ['javascript', javascript],
  ['typescript', typescript], ['markup', markup],
].forEach(([name, language]) => SyntaxHighlighter.registerLanguage(name, language));

const ALIASES = {
  hcl: 'hcl', terraform: 'hcl', tf: 'hcl', tfvars: 'hcl',
  bash: 'bash', sh: 'bash', shell: 'bash', zsh: 'bash', console: 'bash',
  json: 'json', yaml: 'yaml', yml: 'yaml',
  powershell: 'powershell', ps1: 'powershell', pwsh: 'powershell',
  sql: 'sql', python: 'python', py: 'python',
  docker: 'docker', dockerfile: 'docker', ini: 'ini', toml: 'ini',
  javascript: 'javascript', js: 'javascript', typescript: 'typescript', ts: 'typescript',
  xml: 'markup', html: 'markup',
};

const LABELS = { hcl: 'Terraform', bash: 'Bash', json: 'JSON', yaml: 'YAML', powershell: 'PowerShell', sql: 'SQL', python: 'Python', docker: 'Dockerfile', ini: 'INI', javascript: 'JavaScript', typescript: 'TypeScript', markup: 'XML' };

export const normaliseLanguage = (language, fileName) => {
  const fromFile = fileName ? fileName.split('.').pop().toLowerCase() : '';
  if (fileName && /\.tfvars(\.example)?$/i.test(fileName)) return 'hcl';
  return ALIASES[(language || '').toLowerCase()] || ALIASES[fromFile] || null;
};

export const languageLabel = (language) => LABELS[language] || (language ? language.toUpperCase() : 'Text');

export const editorTheme = vscDarkPlus;

export default SyntaxHighlighter;
